import { encodeString, QueryParamConfig, StringParam, withDefault } from 'use-query-params';

export enum VIEW_TYPE {
  orders = 'orders',
  items = 'items',
}

const ViewParam: QueryParamConfig<VIEW_TYPE> = {
  encode: encodeString,
  decode: (input: string | (string | null)[] | null | undefined): VIEW_TYPE =>
    input === 'items' ? VIEW_TYPE.items : VIEW_TYPE.orders,
};

export const purchasesQueryConfig = {
  purchaseId: StringParam,
  filters: StringParam,
  view: withDefault(ViewParam, VIEW_TYPE.orders),
  itemId: StringParam,
};

export type PurchasesQueryConfig = typeof purchasesQueryConfig;
